<template>
    <div class="container">
        <!-- -------------------- -->
        <!-- FALTA TRADUIR -->
        <!-- -------------------- -->

        <div class="alert alert-warning mt-5" role="alert">
          {{$t('s_not_found_not_found')}}
        </div>

        <button
            type="button"
            class="btn btn-outline-dark"
            style="margin: 50px"
            @click="app.routerPush('/')"
        >{{$t('s_not_found_go_to_configurator')}}</button>

    </div>
</template>

<script>
import { app } from "../application.js";

export default {
    name: "notFoundComponent",
    data() {
        return {
            app: app
        };
    },
    components: {},
    methods: {},
    created() {
        app.currentConfiguration.results = [];
        app.currentConfiguration.mainElementParameters = [];
    },
    beforeRouteLeave(to, from, next) {
        this.app.showNavigationBar = true;
        next();
    },
    mounted() {
        //set language to change label languages
        if (!this.app.currentConfiguration.language) {
            this.app.setLanguageFromBrowser();
        }

        //hide navigationbar
        this.app.showNavigationBar = false;
    }
};
</script>

<style lang="scss">
</style>



